const initialState = {
  userReceivedEvents: {},
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "USER_RECEIVED_EVENTS":
      return {
        ...state,
        userReceivedEvents: action.payload,
      };
    default:
      return state;
  }
}
